import api, { URLS } from "@/services/api.js";

const BASE_URL = `${URLS.API_FGTAS}/permissao`;

export const buscarPermissoes = () => {
	return api.get(BASE_URL);
};
